import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Boton, Spinner } from "asocomponents"
import { WEBURLEGALES } from "../../../helpers/frontend.js"
import { setResultadoGrilla } from "../../../redux/resultadoGrillaObservacionesSlice.js"
import { setIdJuicio, resetIdJuicio } from "../../../redux/juicioSlice.js"
import { useNavigate } from 'react-router-dom'
import JuicioServices from "../../../../modules/Juicio/application/JuicioServices.js"

function GrillaJuicios() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const usuarioString = sessionStorage.getItem('usuario') ? JSON.parse(sessionStorage.getItem('usuario')) : null;
    const cuit = usuarioString.usuario

    //Limpio el id de Juicio en caso de haber visualizado
    dispatch(resetIdJuicio())

    //#region const
    const filtros = useSelector((state) => state.rootReducer.filtrosJuicios)

    const [isLoading, setIsLoading] = useState(false)
    const [resultado, setResultado] = useState([])
    const [existenRdos, setExistenRdos] = useState(true)
    const [recargado, setRecargado] = useState(false)


    //PARA EL PAGINADO
    const [paginaActual, setPaginaActual] = useState(1)
    const [elementosPorPagina] = useState(10) // Cambia esto según cuántos elementos quieres mostrar por página

    //Recupero los filtros desde Redux que vienen desde FiltroEnfProfeionales.jsx
    const filtrosCargados = useSelector(state => state.rootReducer.filtrosJuicios.cargados)
    const filtroRapido = useSelector(state => state.rootReducer.filtrosJuicios.filtroRapido)

    //Estado para el menu desplegable de opciones sobre la grilla
    const [showMenuIndex, setShowMenuIndex] = useState(null) // Estado para almacenar el índice de la fila en la que se muestra el menú

    //#region paginado y fetchData
    const indiceUltimoElemento = paginaActual * elementosPorPagina
    const indicePrimerElemento = indiceUltimoElemento - elementosPorPagina
    let totalPaginas = resultado === null ? 1 : Math.ceil(resultado.length / elementosPorPagina)

    const elementosPaginados =
        resultado === null
            ? []
            : resultado.slice(indicePrimerElemento, indiceUltimoElemento)

    const cambiarPagina = (numeroPagina) => {
        setPaginaActual(numeroPagina)
    }

    const handleVerJuicio = (idJuicio) => {
        dispatch(setIdJuicio(idJuicio))
        navigate("/detalleJuicio")
    }

    //const handleVerJuicio = (idJuicio) => {
    //     window.open(
    //         `/detalleJuicio/${idJuicio}`,
    //         '_blank'
    //     )
    // }

    const fecthData = async (filtro) => {
        if (filtro.cargados !== recargado) {

            const [idDelegacion, numeroSiniestro] = (filtro.nroSiniestro || "").split("-");

            setIsLoading(true)
            const juicioService = new JuicioServices()
            juicioService.cuitLetrado=cuit
            juicioService.fechaNotificacionInicio=filtro.fechaNotificacionInicio
            juicioService.fechaNotificacionFin=filtro.fechaNotificacionFin
            juicioService.caratula=filtro.textoBusqueda
            juicioService.idJuicio=filtro.nroJuicio
            juicioService.nroSiniestro=filtro.nroSiniestro
            juicioService.nroRaj=filtro.nroRaj
            juicioService.idEstadoJuicio=filtro.idEstadoJuicio
            
            const result = await juicioService.getJuiciosReingenieria()

            setExistenRdos(result.length > 0)
            setPaginaActual(1)
            setResultado(result)
            dispatch(setResultadoGrilla(result))
            setIsLoading(false)
        }
        setShowMenuIndex(false)
    }
    //#endregion

    //#region effect

    useEffect(() => {
        setRecargado(filtros.cargados)
        fecthData(filtros)
    }, [filtros])

    useEffect(() => {
        if (filtroRapido !== '') {
            // Filtra los objetos en función del texto de búsqueda
            const resultadoFiltradoRapido = resultado.filter((obj) =>
                Object.values(obj).some((val) => val && val.toString().toLowerCase().includes(filtroRapido.toLowerCase())
                )
            )
            setResultado(resultadoFiltradoRapido)
            dispatch(setResultadoGrilla(resultadoFiltradoRapido))
        }
        else
            fecthData(filtros)

    }, [filtroRapido])


    useEffect(() => {
        if (localStorage.getItem("documentos"))
            localStorage.removeItem("documentos")
    }, [])

    //#endregion

    if (isLoading) {
        return <Spinner color="red" size="50" />
    }

    return (
        <div className="overflow-hidden">
            <div className="shadow-md sm:rounded-lg mr-2 ml-2">
                <table className="table-fixed text-xs text-left rtl:text-right text-gray-500 w-[98%] ">
                    <thead className="text-[0.6rem] text-gray-700 uppercase bg-gray-200">
                        <tr>
                            <th scope="col" className="text-center  py-3" style={{ width: "10%" }}>
                                Fecha
                            </th>
                            <th scope="col" className="text-center  py-3" style={{ width: "10%" }}>
                                Nro. Juicio
                            </th>
                            <th scope="col" className="text-center  py-3" style={{ width: "10%" }}>
                                Tipo
                            </th>
                            <th scope="col" className="text-center  py-3" style={{ width: "30%" }}>
                               Caratula
                            </th> 
                            <th scope="col" className="text-center py-3" style={{ width: "10%" }}>
                                Nro. Siniestro
                            </th>
                            <th scope="col" className="text-center py-3" style={{ width: "10%" }}>
                                Crítico
                            </th>
                            <th scope="col" className="text-center py-3" style={{ width: "15%" }}>
                                Instancia
                            </th>
                            <th scope="col" className="text-center py-3"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {elementosPaginados &&
                            elementosPaginados.map((obs, index) => (
                                <tr
                                    className="bg-white border-b hover:bg-gray-50 text-xs font-normal"
                                    key={obs.idJuicio}
                                >
                                    <td className="text-center py-2">{obs.fechaNotificacion}</td>
                                    <td className="text-center py-2">{obs.idJuicio}</td>
                                    <td className="text-center py-2">{obs.tipoJuicio}</td>
                                    <td className="text-center py-2">{obs.caratula}</td>
                                    <td className="text-center py-2">{obs.nroSiniestro}</td>
                                    <td className="text-center py-2">{obs.marcaCritico}</td>
                                    <td className="text-center py-2">{obs.estado}</td>
                                    <td className="text-center py-2">
                                        <div className="flex flex-row">
                                            <Boton type="button" icono="eye" width="w-2" onClick={() => handleVerJuicio(obs.idJuicio)} />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
            {!existenRdos &&
                <div className="flex flex-row items-center justify-center h-full">
                    <div className="font-semibold text-lg text-center mb-4">
                        No encontramos ningún registro para tu búsqueda
                    </div>
                    <div className="w-[300px] flex justify-center ml-40">
                        <img src={`${WEBURLEGALES}/images/papers.svg`} alt="Sin resultados" />
                    </div>
                </div>
            }
            <div className="col-span-2 flex justify-end items-center m-2">
                <span className="text-sm m-1">
                    Página {paginaActual} de {totalPaginas === 0 ? 1 : totalPaginas}
                </span>
                <button
                    className="bg-white hover:bg-gray-200 hover:text-white text-black p-1 rounded border-solid border-[1px] border-gray-400 w-8"
                    onClick={() => cambiarPagina(paginaActual - 1)}
                    disabled={paginaActual === 1}
                >
                    {"<"}
                </button>
                <button
                    className="bg-white hover:bg-gray-200 hover:text-white text-black p-1 rounded border-solid border-[1px] border-gray-400 w-8"
                    onClick={() => cambiarPagina(paginaActual + 1)}
                    disabled={resultado ? indiceUltimoElemento >= resultado.length : true}
                >
                    {">"}
                </button>
            </div>
        </div>
    )
}

export default GrillaJuicios